const MODAL_KEY = "modal";
const MODAL_EXTRA_KEYS = [
  "cbeId",
  "cbeV",
  "dlqItemPk",
  "comparisonEnvironment",
  "stTab",
  "stFilter",
  "stQ",
] as const;
const COMPARE_KEYS = [
  "cmpLeft",
  "cmpRight",
  "cmpUsecase",
  "cmpDest",
  "cmpProduct",
  "cmpStage",
] as const;
const ALL_MODAL_KEYS = [
  MODAL_KEY,
  ...MODAL_EXTRA_KEYS,
  ...COMPARE_KEYS,
] as const;

export { ALL_MODAL_KEYS };

export function setModalParam(modal: string, extras?: Record<string, string>) {
  const url = new URL(window.location.href);
  for (const key of ALL_MODAL_KEYS) url.searchParams.delete(key);
  url.searchParams.set(MODAL_KEY, modal);
  if (extras) {
    for (const [k, v] of Object.entries(extras)) url.searchParams.set(k, v);
  }
  window.history.replaceState(null, "", url.toString());
}

export function clearModalParam() {
  const url = new URL(window.location.href);
  for (const key of ALL_MODAL_KEYS) url.searchParams.delete(key);
  window.history.replaceState(null, "", url.toString());
}

/** Pure read — no side effects. Safe for useState initializers and React Strict Mode. */
export function readInitialModal(): {
  modal: string | null;
  cbeId: string | null;
  cbeV: string | null;
  dlqItemPk: string | null;
  comparisonEnvironment: string | null;
  stTab: string | null;
  stFilter: string | null;
  stQ: string | null;
} {
  const params = new URLSearchParams(window.location.search);
  const modal = params.get(MODAL_KEY);
  if (modal === "event-json" || modal === "cbe-json" || modal === "cbe-error") {
    return {
      modal,
      cbeId: params.get("cbeId"),
      cbeV: params.get("cbeV"),
      dlqItemPk: null,
      comparisonEnvironment: null,
      stTab: null,
      stFilter: null,
      stQ: null,
    };
  }
  if (modal === "dlq-json" || modal === "dlq-error") {
    return {
      modal,
      cbeId: null,
      cbeV: null,
      dlqItemPk: params.get("dlqItemPk"),
      comparisonEnvironment: null,
      stTab: null,
      stFilter: null,
      stQ: null,
    };
  }
  if (modal === "shadow-test") {
    return {
      modal,
      cbeId: null,
      cbeV: null,
      dlqItemPk: null,
      comparisonEnvironment: params.get("comparisonEnvironment"),
      stTab: params.get("stTab"),
      stFilter: params.get("stFilter"),
      stQ: params.get("stQ"),
    };
  }
  if (modal === "dlq") {
    return {
      modal,
      cbeId: null,
      cbeV: null,
      dlqItemPk: null,
      comparisonEnvironment: null,
      stTab: null,
      stFilter: null,
      stQ: null,
    };
  }
  return {
    modal: null,
    cbeId: null,
    cbeV: null,
    dlqItemPk: null,
    comparisonEnvironment: null,
    stTab: null,
    stFilter: null,
    stQ: null,
  };
}
